import {Component, EventEmitter, Output, ViewChild} from '@angular/core';

import {CaseAsset} from '../case-asset';
import {CaseAssetService} from '../case-asset.service';

@Component({
  selector: 'app-case-asset-create',
  templateUrl: 'create.component.html',
})
export class CaseAssetCreateComponent {
  @ViewChild('staticModal') staticModal;

  @Output() completed = new EventEmitter<boolean>();

  public disabled: boolean = false;

  public model: CaseAsset = new CaseAsset();

  private givenCaseId: string;

  constructor(private readonly caseAssetService: CaseAssetService) {}

  public get caseId(): string {
    return this.givenCaseId;
  }

  public open(caseId: string): void {
    this.givenCaseId = caseId;
    this.staticModal.show();
  }

  public close() {
    this.workCompleted();
  }

  public confirmCreate($event) {
    $event.preventDefault();
    this.disabled = true;
    this.caseAssetService
      .createCaseAsset(this.model, { parameters: { id: this.caseId } })
      .subscribe(() => {
        this.workCompleted();
      });
  }

  private workCompleted() {
    this.model = new CaseAsset();
    this.disabled = false;
    this.staticModal.hide();
    this.completed.next(true);
  }
}
